import React from "react";

/**
 * Small building blocks for skeleton loading UI. Uses Tailwind's animate-pulse.
 * All variants mimic the shape of the real content so the swap-in feels seamless.
 */

export function SkeletonBlock({ className = "" }) {
  return <div className={`bg-sand/50 rounded animate-pulse ${className}`} />;
}

export function SkeletonVenueCard() {
  return (
    <div className="rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm">
      <SkeletonBlock className="aspect-[4/3] rounded-none" />
      <div className="p-5 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <SkeletonBlock className="h-5 w-2/3" />
          <SkeletonBlock className="h-5 w-10" />
        </div>
        <SkeletonBlock className="h-4 w-full" />
        <SkeletonBlock className="h-4 w-4/5" />
        <div className="flex justify-between pt-2">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="h-3 w-16" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonEventCard() {
  return (
    <div className="rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm">
      <SkeletonBlock className="aspect-[16/10] rounded-none" />
      <div className="p-5 space-y-3">
        <SkeletonBlock className="h-3 w-24" />
        <SkeletonBlock className="h-5 w-3/4" />
        <SkeletonBlock className="h-4 w-full" />
        <SkeletonBlock className="h-3 w-1/2" />
      </div>
    </div>
  );
}

export function SkeletonStoryCard() {
  return (
    <div className="rounded-2xl overflow-hidden bg-white border border-black/5">
      <SkeletonBlock className="aspect-[16/10] rounded-none" />
      <div className="p-5 space-y-2">
        <SkeletonBlock className="h-5 w-4/5" />
        <SkeletonBlock className="h-4 w-full" />
        <SkeletonBlock className="h-4 w-2/3" />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 6, Card = SkeletonVenueCard }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={`skel-${i}`} />
      ))}
    </div>
  );
}
